// TODO: write test this file
export const addClassNameByTagName = (tagName, className) => document.getElementsByTagName(tagName)[0].className += ` ${className}`;

export const removeClassNameTagName = (tagName, className) => document.getElementsByTagName(tagName)[0].className = className;
